import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Chip,
} from "@mui/material";
import { Add, Remove } from "@mui/icons-material";
import { Grid2 } from "@mui/material";
import EditableServiceCard from "./EditableServiceCard";
import { Employee, Service } from "../../../types";
import { WEBSITE_ID } from '../../../projectConfig';

interface EditableServicesSectionProps {
  services: Service[];
  employees: Employee[];
  onSaveService: (oldService: Service, updatedService: Service, serviceImage?: File) => void;
  onDeleteService: (service: Service) => void;
  siteId?: string;
  categoryFilter?: string | null;
  resourcePluralLabel?: string;
}

const EditableServicesSection: React.FC<EditableServicesSectionProps> = ({
  services,
  employees,
  onSaveService,
  onDeleteService,
  siteId = WEBSITE_ID,
  categoryFilter,
  resourcePluralLabel = 'Employees',
}) => {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  const filteredServices = categoryFilter
    ? services.filter((service) => service.category === categoryFilter)
    : services;


  const handleToggle = (index: number) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <Grid2 container spacing={2}>
      {filteredServices.length === 0 && (
        <Typography variant="body1" sx={{ mt: 2, ml: 1 }}>
          No services found for this category.
        </Typography>
      )}
      {filteredServices.map((service, index) => (
        <Grid2 size={{ xs: 12, sm: 6, md: 4 }} key={index}>
          <Accordion
            expanded={expandedIndex === index}
            onChange={() => handleToggle(index)}
            sx={{
              boxShadow: "none",
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
              "&:before": { display: "none" },
            }}
          >
            <AccordionSummary
              expandIcon={expandedIndex === index ? <Remove /> : <Add />}
              aria-controls={`panel${index}-content`}
              id={`panel${index}-header`}
              sx={{ p: 0 }}
            >
              {expandedIndex !== index && (
                <Typography variant="h6" sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                  {service.title}
                  {/* {service.category && ( */}
                  <Chip
                    label={service.category || 'Uncategorized'}
                    size="small"
                    color={service.category ? 'primary' : 'default'}
                    sx={{ fontWeight: 500, textTransform: 'capitalize' }}
                  />
                  {/* )} */}
                </Typography>
              )}
            </AccordionSummary>
            <AccordionDetails sx={{ p: 0 }}>
              <EditableServiceCard
                initialService={service}
                onSaveService={onSaveService}
                onDeleteService={onDeleteService}
                employees={employees}
                siteId={siteId}
                resourcePluralLabel={resourcePluralLabel}
              />
            </AccordionDetails>
          </Accordion>
        </Grid2>
      ))}
    </Grid2>
  );
};

export default EditableServicesSection;
